module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row margin-20"
  }, [_vm._v("\n      Para saber a posição correta de instalação, selecione a categoria do veículo abaixo:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.scroll('guide-light-vehicles')
      }
    }
  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.scroll('guide-heavy-vehicles')
      }
    }
  }, [_vm._m(3)])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Guia de instalação do TAG")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('h4', {
    staticClass: "bold margin-20"
  }, [_vm._v("Aprenda aqui como instalar seu TAG Move Mais, de maneira rápida e prática.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "alert-info-title"
  }, [_vm._v("Importante!")]), _vm._v(" "), _c('span', {
    staticClass: "alert-info-txt"
  }, [_vm._v("O TAG deve ser colado dentro do veículo, na parte interna do para-brisa e em posição horizontal, pois não irá funcionar se estiver em outra posição.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('img', {
    staticClass: "img-tag-fix",
    attrs: {
      "src": require("../../assets/img/install-guide/img-tag-horizontal-alert.svg"),
      "alt": ""
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-light-vehicles"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/install-guide/icon-light-vehicles.svg"),
      "alt": "",
      "width": "25%"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "sub-title light-vehicles"
  }, [_vm._v("Veículos Leves")]), _vm._v(" "), _c('b', [_vm._v("Automóveis, Utilitários, Caminhonetes, etc.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-heavy-vehicles"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/install-guide/icon-heavy-vehicles.svg"),
      "alt": "",
      "width": "25%"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "sub-title heavy-vehicles",
    attrs: {
      "id": "guide-light-vehicles"
    }
  }, [_vm._v("Veículos Pesados")]), _vm._v(" "), _c('b', [_vm._v("Ônibus, Micro-ônibus, Caminhões, etc.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('h3', {
    staticClass: "sub-title light-vehicles"
  }, [_vm._v("Veiculos Leves")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "row margin-b20"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('img', {
    staticClass: "img-border",
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-car.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-car-detail.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("\n                  A maioria dos veículos leves possuem uma área livre próximo ao retrovisor para a aplicação do TAG.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-b20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("Com retícula")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('img', {
    staticClass: "img-border",
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-car-grid.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-car-grid-detail.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("\n                  Caso o veículo tenha retícula (área pontilhada), o TAG deve ser colado fora desta área, logo abaixo, de preferência centralizado no para-brisa.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-b20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("Com suporte ao retrovisor")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('img', {
    staticClass: "img-border",
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-car-support.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-car-support-detail.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("\n                  Há veículos que possuem um suporte ao retrovisor no centro do para-brisa. Neste tipo de veículo, o TAG deve ser colado\nem qualquer um dos lados desse suporte, mas deve também respeitar 4 dedos de distância do topo do para-brisa.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-b20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("Com para-brisa panorâmico")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "img-border",
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-car-panoramic-view.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("\n                  Caso o veículo tenha retícula (área pontilhada), o TAG deve ser colado fora desta área, logo abaixo, de preferência centralizado no para-brisa.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "position-link",
    attrs: {
      "id": "guide-heavy-vehicles"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('h3', {
    staticClass: "sub-title heavy-vehicles"
  }, [_vm._v("Veículos Pesados")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "row margin-b20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("\n                  Independentemente de marca ou modelo, a posição do TAG no vidro nunca pode ser coberta pelo curso do limpador do para-brisa. Ache o melhor local com o limpador funcionando.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-b20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "sub-title upper"
  }, [_vm._v("Caminhões")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('img', {
    staticClass: "img-border",
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-truck.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-truck-detail.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("\n                  O TAG deve ser colado 10 dedos acima do rodapé do para-brisa, no centro do vidro.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-b20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "sub-title upper"
  }, [_vm._v("Ônibus")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("Com limpador de para-brisa de baixo para cima")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('img', {
    staticClass: "img-border",
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-bus-bottom.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-bus-bottom-detail.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("\n                  O TAG deve ser colado a uma distância de 1,20m do chão. Caso exista uma barra central no vidro, cole a\n                  uma distância mínima lateral de 4 dedos da barra.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-b20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("Com limpador de para-brisa de cima para baixo")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('img', {
    staticClass: "img-border",
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-bus-top.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-bus-bottom-detail-top.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("\n                  O TAG deve ser colado a uma distância de 1,20m do chão. Caso exista uma barra central no vidro, cole a\n                  uma distância mínima lateral de 4 dedos da barra.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-b20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("Com limpador de para-brisa de dentro para fora")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('img', {
    staticClass: "img-border",
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-bus.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/install-guide/img-install-tag-bus-detail.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("\n                  O TAG deve ser colado a uma distância entre 1,40m e 1,90m a partir do chão do veículo. Caso exista uma barra central no\n                  vidro, cole a uma distância mínima lateral de 4 dedos da barra.\n                ")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning margin-t30"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert-info-title margin-b10"
  }, [_vm._v("Veículos com particularidades")]), _vm._v("\n          Há veículos que possuem particularidades que podem atrapalhar ou mesmo impedir o funcionamento do TAG. Algumas particularidades que podem\n          ocasionar problemas de funcionamento: desembaçador de vidro, blindagem e películas com componentes metálicos etc.\n          "), _c('br'), _c('br'), _vm._v("\n          Verifique sempre com os fabricantes e, em caso de dúvida, entre em contato com nossa "), _c('b', [_vm._v("Central de Relacionamento pelo número 4000 2901\n          (regiões metropolitanas) ou 0800 777 1022 (demais localidades).")]), _vm._v(".\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-55e7e9a1!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/guide.vue
// module id = 2131
// module chunks = 1